import { Image } from 'common/components/image';
import { TestableComponent } from 'common/interfaces';
import React from 'react';
import './Card.styles';

interface TextCardProps extends TestableComponent {
  title: string;
  bgUrl?: string;
}

function TextCard({ title, bgUrl, testId }: TextCardProps) {
  return (
    <div className="text-card-container" data-test-id={testId}>
      {bgUrl && <Image className="no-transition" src={bgUrl} />}
      <span>{title}</span>
    </div>
  );
}

export default React.memo(TextCard);
